module.exports = __webpack_public_path__ + "pc/img/loading.942c9707.svg";